import React, { useEffect, useRef, useState } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
import { PropTypes } from "prop-types";
import Logo from "../../assets/img/custom/logo.png";
import {
  Button,
  Collapse,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  Modal,
  ModalBody,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "store/actions/authAction";

var ps;

const Sidebar = (props) => {
  let dispatch = useDispatch();
  const [logoutModal, setLogoutModal] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const logoutToggle = () => {
    setLogoutModal(!logoutModal);
  };
  const [collapseOpen, setCollapseOpen] = useState();
  const activeRoute = (routeName) => {
    return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };
  const closeCollapse = () => {
    setCollapseOpen(false);
  };

  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      if (
        (prop.layout == "/school" && user.type == "school platform") ||
        (prop.layout == "/collective" && user.type == "collective")
      ) {
        if (user.role == "school-sub-admin" && prop.subAdmin) {
          return (
            <NavItem key={key}>
              <NavLink
                to={prop.layout + prop.path}
                tag={NavLinkRRD}
                onClick={closeCollapse}
                className={`sidebar-link d-flex align-items-center p-2 rounded ${
                  activeRoute(prop.layout + prop.path)
                    ? "active-link"
                    : "text-white"
                }`}
              >
                <div className="tooltip-container">
                  {prop.name}
                  {prop.tooltip && (
                    <span className="tooltip-text">{prop.tooltip}</span>
                  )}
                </div>
              </NavLink>
            </NavItem>
          );
        } else if (user.role == "school-admin") {
          return (
            <NavItem key={key}>
              <NavLink
                to={prop.layout + prop.path}
                tag={NavLinkRRD}
                onClick={closeCollapse}
                className={`sidebar-link d-flex align-items-center p-2 rounded ${
                  activeRoute(prop.layout + prop.path)
                    ? "active-link"
                    : "text-white"
                }`}
              >
                <div className="tooltip-container">
                  {prop.name}
                  {prop.tooltip && (
                    <span className="tooltip-text">{prop.tooltip}</span>
                  )}
                </div>
              </NavLink>
            </NavItem>
          );
        }
      }
    });
  };


  const { bgColor, routes, logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }

  return (
    <Navbar
      className="navbar-vertical fixed-left navbar-light bg-primary custom-sidebar"
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-icon" />
        </button>
        <Nav className="align-items-center d-md-none">
          <Button onClick={logoutToggle}>Logout</Button>
        </Nav>
        <Collapse navbar isOpen={collapseOpen}>
          <div className="navbar-collapse-header d-md-none">
            <Row>
              {logo ? (
                <Col className="collapse-brand" xs="6">
                  {logo.innerLink ? (
                    <Link to="https://fans-help-players-athlete.web.app/">
                      <img alt={logo.imgAlt} src={Logo} />
                    </Link>
                  ) : (
                    <a href="https://fans-help-players-athlete.web.app/">
                      <img alt={logo.imgAlt} src={Logo} />
                    </a>
                  )}
                </Col>
              ) : null}
              <Col className="collapse-close" xs="6">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleCollapse}
                >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>
          <Nav navbar>{createLinks(routes)}</Nav>
        </Collapse>
      </Container>
      <Modal isOpen={logoutModal} centered toggle={logoutToggle}>
        <ModalBody>
          <div className="text-center">
            <i
              className="fa fa-sign-out-alt text-primary"
              style={{ fontSize: 70 }}
            ></i>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 16 }}>
              You want to logout.
            </span>
            <br />
            <br />
            <br />
            <Button color="secondary" onClick={logoutToggle}>
              Cancel
            </Button>{" "}
            <Button color="primary" onClick={() => dispatch(logout())}>
              Logout
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </Navbar>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
